import { render, staticRenderFns } from "./recruiting.vue?vue&type=template&id=00fef850&scoped=true&"
import script from "./recruiting.vue?vue&type=script&lang=js&"
export * from "./recruiting.vue?vue&type=script&lang=js&"
import style0 from "./recruiting.vue?vue&type=style&index=0&id=00fef850&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fef850",
  null
  
)

export default component.exports